export default {
  login (state, payload) {

  },
  LOGOUT (state, payload) {
    localStorage.removeItem('user_token')
    localStorage.removeItem('subscription')
    state.subscription = null
    state.access_token = null
  },
  SUBSCRIPTION_STATUS (state, payload) {
    localStorage.setItem('subscription', payload)
    state.subscription = payload
  }
}
